import http from 'plugins/axios';

export default {
    commentList(data) {
        return http.get({
            url: '/admin/comment/list',
            data
        })
    },
    update(data) {
        return http.post({
            url: '/admin/comment/update',
            data,
            dataType: 'form'
        })
    }
};

// ,
//